import { gsap, SplitText } from '../gsap.js';

const fadeSettings = {
  yPercent: 40,
  duration: 0.9,
  ease: 'power3.out'
};

const linesSettings = {
  yPercent: 110,
  duration: 1.1,
  stagger: 0.09,
  ease: 'power4.out'
};

/**
 * Appends a fade-up reveal for one element to an existing timeline.
 * Silently skips when the page has no such element, so the same stack can be
 * reused by pages that only render part of it.
 *
 * @param {gsap.core.Timeline} timeline Timeline to append to.
 * @param {string} selector Element to reveal.
 * @param {string|number} position Start position on that timeline.
 */

export function fadeUp(timeline, selector, position) {
  const targets = gsap.utils.toArray(document.querySelectorAll(selector));

  if (!targets.length) return;

  timeline.fromTo(
    targets,
    { yPercent: fadeSettings.yPercent, autoAlpha: 0 },
    {
      yPercent: 0,
      autoAlpha: 1,
      duration: fadeSettings.duration,
      ease: fadeSettings.ease
    },
    position
  );
}

/**
 * Appends a masked line-by-line reveal for one text element. The element is
 * split on the spot, so fonts must already be settled when this runs.
 *
 * @param {gsap.core.Timeline} timeline Timeline to append to.
 * @param {string} selector Text element to split and reveal.
 * @param {string|number} position Start position on that timeline.
 */

export function revealLines(timeline, selector, position) {
  const target = document.querySelector(selector);

  if (!target) return;

  const split = new SplitText(target, { type: 'lines', mask: 'lines' });

  timeline
    .set(target, { autoAlpha: 1 }, position)
    .fromTo(
      split.lines,
      { yPercent: linesSettings.yPercent },
      {
        yPercent: 0,
        duration: linesSettings.duration,
        stagger: linesSettings.stagger,
        ease: linesSettings.ease
      },
      position
    );
}
